import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { selectAllCompanies, selectCompaniesByName, selectCompaniesById } from './store/reducers';
import { UUID } from 'angular2-uuid';
import { Company } from './companies.model';
import * as CompanyActions from './store/actions/companies.actions';
// import * as SiteActions from '../sites/store/actions/sites.actions';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { catchError, map, finalize, tap } from 'rxjs/operators';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/compat/firestore';


@Injectable({
  providedIn: 'root'
})
export class CompaniesService {
  messages$: any;
  private url = '';
  private endpoint = 'companies';
  private subscriptionLength = 14;
  public companyChangeRef = new BehaviorSubject<any>([]);

  constructor(
    private httpClient: HttpClient,
    private store: Store<any>,
    protected db: AngularFirestore,
  ) {

    const preCompanies = [
      '1st message',
      '2nd message',
      '3rd message',
      '4th message',
      '5th message'
    ];
  }

  // addCompanyFirebase$(company: Company) {

  //   var cityRef = this.db.collection('companies').add(company);

  //   var setWithMerge = cityRef.set({
  //     capital: true
  // }, { merge: true });

  //   return of(this.db.collection('companies').add(company)
  //   .then((ref) => {

  //     ref.set({ extra_idField: ref.id }, { merge: true }).then(() => {
  //       console.log("Your extra id field has been created");
  //     });

  //   }));
  //   // .then(() => {
  //   //   console.log('this.db.collection(companies).add(company) success');

  //   // }).catch((error) => {
  //   //   console.error('Error adding new companies document: ', error);
  //   // });
  // };


  public changeCompany(company: Company, ngTemplateRqd: number) {
    const message = {
      company: company,
      ngTemplateRqd: ngTemplateRqd
    }
    this.companyChangeRef.next(message);
  }
  
  addCompanyFirebase$(company: Company) {
    return this.db.collection('companies').add(company);
  }

  addCompany(value: any) {
    const company: Company = {
      companyName: value.companyName,
      contactName: value.contactName,
      contactTitle: value.contactTitle,
      email: value.email,
      address: value.address,
      city: value.city,
      region: value.region,
      postalCode: value.postalCode,
      country: value.country,
      phone: value.phone,
      // id: this.generateUUID(),
      startDate: new Date(),
      programId: 1,
      dsEndDate: new Date(new Date().setDate(new Date().getDate() + this.subscriptionLength)),
    };
    this.store.dispatch(new CompanyActions.AddCompany(company));

  }

  deleteCompany(id: any) {
    this.store.dispatch(new CompanyActions.DeleteCompany(id));
  }

  destroyCompany(id: any) {
    this.store.dispatch(new CompanyActions.DestroyCompany(id));
  }

  destroyCompanyFirebase$(id: string) {
    return this.db.collection('companies').doc(id).delete();
  }

  updateCompany(company: any) {
    // message.dateResolved = new Date();
    this.store.dispatch(
      new CompanyActions.UpdateCompany(company)
    );
  }

  updateCompanyFirebase$(company: any) {
    console.log('updateCompany$: e', company);

    const productsRef: AngularFirestoreDocument<any> = this.db.collection('companies').doc(company.id);
    company.file = null;
    const companyData: any = Object.assign({}, company);

    return of(productsRef.set(companyData, { merge: true }));
  }

  getCompanies() {
    this.store.dispatch(new CompanyActions.FetchCompanies());
  }

  getCompanies$(): Observable<any> {

    const companiesCollection = this.db.collection<Company>('companies', ref => ref
      // .orderBy('id', 'asc')
      .orderBy('startDate', 'desc')
    );

    console.log('companiesCollection=======', companiesCollection);

    return companiesCollection.snapshotChanges()
      .pipe(
        map(actions => {
          return actions.map(a => {
            const data = a.payload.doc.data() as any;
            const id = a.payload.doc.id;
            return { id, ...data };
          });
        })
      );
  }

  getCompaniesByCompanyId(companyId: string) {
    this.store.dispatch(new CompanyActions.FetchCompany(companyId));
  }

  getCompaniesByCompanyId$(companyId: string): Observable<any> {


    // I dont know why the filter in the collection does not work on id as it does with other
    // fields. So i have a filter on the snapshotchanges. Lost good day on this.
    // tap is just for my sanity on looping the collection.
    const companiesCollection = this.db.collection<any>('companies', ref => ref
      // .where('id', '==', companyId)
    );

    return companiesCollection.snapshotChanges()
      .pipe(

        // tap(snaps => {
        //   snaps.forEach((snap) => {
        //     console.log('snap.payload.doc.id: ', snap.payload.doc.id)
        //   })
        // }),

        map((snaps:any) => snaps.filter((snap:any) => snap.payload.doc.id === companyId)),
        map((actions:any) => {
          return actions.map((a:any) => {
            const data = a.payload.doc.data() as Company;
            const id = a.payload.doc.id;
            return { id, ...data };
          });
        })
      );
  }

  getCompaniesByCompaniesCutOffDate$(cutOffDate: Date): Observable<any> {


    const companiesCollection = this.db.collection<any>('companies', ref => ref
      .where('dsEndDate', '<', cutOffDate)
    );

    return companiesCollection.snapshotChanges()
      .pipe(
        map(actions => {
          return actions.map(a => {
            const data = a.payload.doc.data() as any;
            const id = a.payload.doc.id;
            return { id, ...data };
          });
        })
      );
  }

  // (companies: Company[], { cutOffDate }: { cutOffDate: Date }) => companies.filter(company => new Date(company.dsEndDate).getTime() <= cutOffDate.getTime())

  getCompaniesByName(companyName: string) {
    this.store.dispatch(new CompanyActions.FetchCompaniesByCompanyName(companyName));
  }

  findcompanys(
    sortProperty: any,
    sortOrder = '%2B',
    pageNumber = 10,
    pageSize = 3): Observable<Company[]> {

    const queryParams = `?Sort=${sortOrder}${sortProperty}&Skip=${pageNumber * pageSize}&Take=${pageSize}`;
    return this.listByQueryParams(queryParams).pipe(
      map((res: Company[]) => res),
    );

  }

  findcompaniesByName(name: string): Observable<Company[]> {

    return this.store.select(selectCompaniesByName, { name });

  }

  findcompaniesByCompanyId(companyId: string): Observable<Company[]> {

    return this.store.select(selectCompaniesById, { id: companyId });

  }


  listByQueryParams(queryParams: any): Observable<Company[]> {
    return this.httpClient
      .get<Company[]>(`${this.url}/${this.endpoint}${queryParams}`);
  }

  list(): Observable<Company[]> {
    return this.httpClient
      .get<Company[]>(`${this.url}/${this.endpoint}`);
  }

  findcompanies(
    sortProperty: any,
    sortOrder = '%2B',
    pageNumber = 10,
    pageSize = 3): Observable<Company[]> {

    // const queryParams = `?Sort=${sortOrder}${sortProperty}&Skip=${pageNumber * pageSize}&Take=${pageSize}`;

    return this.store.pipe(
      select(selectAllCompanies),
      // map((mediaLibraries: MediaLibrary[]) => mediaLibraries.filter((mediaLibrary: MediaLibrary) => mediaLibrary.groupId === this.group.id)),
    );

    // return this.listByQueryParams(queryParams).pipe(
    //   map((res: Company[]) => res),
    // );

  }

  findcompaniesById(id: string): Observable<Company[]> {

    return this.store.pipe(
      select(selectCompaniesById, { id }),
      // map((companies: Company[]) => companies.filter((company: Company) => company.id === this.companyId)),
    );


  }

  generateUUID(): string{
    return UUID.UUID();
  }
}
